import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useMemberAuth } from "../lib/auth";
import EditableImage from "../components/EditableImage";

const MemberLogin = () => {
  const { login } = useMemberAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (searchParams.get("expired") === "1") {
      toast.error("Session expired. Please sign in again.", { id: "session-expired" });
    }
  }, [searchParams]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/members/login", { email, password });
      login(data.token, { email: data.email, name: data.name });
      navigate("/members/catalog");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid md:grid-cols-2 min-h-[80vh]" data-testid="member-login-page">
      <div className="hidden md:block overflow-hidden">
        <EditableImage
          imageKey="member_login"
          fallback="https://images.unsplash.com/photo-1551489186-cf8726f514f8?w=1400&q=80"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex items-center justify-center p-10 md:p-20">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="member-login-form">
          <h1 className="font-display text-4xl uppercase tracking-tighter leading-none">Sign In</h1>
          <div className="mt-10 space-y-8">
            <input
              type="email"
              required
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-bare"
              data-testid="member-login-email"
            />
            <input
              type="password"
              required
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-bare"
              data-testid="member-login-password"
            />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full mt-10" data-testid="member-login-submit">
            {loading ? "..." : "Sign In"}
          </button>
          <div className="mt-8 text-xs text-black/55">
            <Link to="/members" className="underline hover:opacity-60" data-testid="member-login-back">
              How to become a member
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MemberLogin;
